import { RouteResource, ShiftResource, TurnResource } from '~/generated';

export class Shift {
  id: number;

  startDate: string;

  endDate: string;

  turns: TurnResource[];

  constructor(shift: ShiftResource) {
    if (!shift.id) {
      throw new Error('Shift id is required');
    }
    this.id = shift.id;
    this.startDate = shift.startDate;
    this.endDate = shift.endDate;
    this.turns = (shift.turns as unknown as TurnResource[]) || [];
  }

  getTurnWithRoute(routeId: number): TurnResource {
    return (
      this.turns.find((turn) => (turn.route as RouteResource).id === routeId) ||
      this.turns[0]
    );
  }
}
